<template>
    <div class="animated fadeIn">
        <kgr-back-to-overview :club-id="clubId" />
        <div class="kgr-row kgr-postfix kgr-postfix--center kgr-postfix--gutters kgr-postfix--medium-stacked">
            <div class="kgr-postfix__fluid">
                <h2 class="kgr-headline kgr-headline--h2">
                    {{ offering.title }} {{ offering.customId ? `/ ${offering.customId}` : '' }}
                </h2>
            </div>
            <div class="kgr-postfix__fixed">
                <div class="kgr-postfix kgr-postfix--center kgr-postfix--smallGutters kgr-postfix--tiny-stacked">
                    <div
                        v-if="offering.isBookingModeOffering() && showAddParticipant"
                        class="kgr-postfix__fixed"
                    >
                        <kgr-offering-live-search-result-preview
                            :club-id="clubId"
                            :offering="offering"
                            :loading-add-participant="loadingAddParticipant"
                            @member-selected="(data) => addParticipantToOffering(data, offering)"
                            @update:selected-sales-list-offering-items="selectedSalesListOfferingItems = $event"
                        />
                    </div>
                    <div
                        v-if="offering.isBookingModeOffering() && showAddParticipant"
                        class="kgr-postfix__fixed"
                    >
                        <button
                            class="kgr-button kgr-button--danger"
                            @click="cancelAddParticipant"
                        >
                            {{ $t('Abbrechen') }}
                        </button>
                    </div>
                    <div
                        v-if="offering.isBookingModeOffering()"
                        class="kgr-postfix__fixed"
                    >
                        <button
                            class="kgr-button kgr-button--accent"
                            @click="editParticipant()"
                        >
                            {{ $t('Teilnehmer hinzufügen') }}
                        </button>
                    </div>
                    <div
                        v-if="canDuplicate"
                        class="kgr-postfix__fixed"
                    >
                        <a
                            class="kgr-button kgr-button--accent"
                            style="margin-right: var(--kgr-input-padding-horizontal);"
                            :href="duplicateGenericUrl"
                        >
                            <kgr-icon
                                icon-class="add"
                                small
                                circle
                                highlight
                                class="kgr-button__icon kgr-button__icon--left"
                            />
                            <span v-t="'offering.generic.duplicate'"></span>
                        </a>
                    </div>
                    <div
                        v-if="offering.isBookingModeOffering()"
                        class="kgr-postfix__fixed"
                    >
                        <button

                            class="kgr-button kgr-button--accent"
                            @click="openConfirmCancellationModal()"
                        >
                            {{ $t('offering.storno') }}
                        </button>
                    </div>
                    <div class="kgr-postfix__fixed">
                        <button
                            v-if="canEdit"
                            class="kgr-button kgr-button--accent"
                            @click="redirectToEdit(offering)"
                        >
                            <kgr-icon-edit />
                            {{ $t('offering.editOffering') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="kgr-row">
            {{ offering.description ? offering.description : '&nbsp;' }}
        </div>
        <div class="kgr-row">
            <div class="kgr-grid kgr-grid--1of2 kgr-grid--large-1of4 kgr-grid--gutters">
                <div class="kgr-grid__cell">
                    <div
                        class="kgr-definitionList kgr-region kgr-region--lightGray kgr-region--rounded"
                        style="height: 100%;"
                    >
                        <kgr-offering-image-view :offering="offering" />
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.sports') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ offering.sport ? offering.sport.name : '-' }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.offeringCategory') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ offering.offeringCategory ? offering.offeringCategory.name : '-' }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.bookable') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            <span style="white-space: pre;">{{ bookableString }} </span>
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('Abteilungen') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getDepartmentNames(offering.departments) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('Teams') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getTeamNames(offering.teams) }}
                        </div>
                    </div>
                </div>
                <div class="kgr-grid__cell">
                    <div
                        class="kgr-definitionList kgr-region kgr-region--lightGray kgr-region--rounded"
                        style="height: 100%;"
                    >
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.interval') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getInterval(offering) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.participants') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ $t('offering.min') }}:
                            {{ offering.minParticipants ? offering.minParticipants : '-' }} /
                            {{ $t('offering.max') }}:
                            {{ offering.maxParticipants ? offering.maxParticipants : '-' }}
                            <span v-if="offering.useWaitList"> ({{ $t('offering.withWaitList') }})</span>
                            <span v-else> ({{ $t('offering.withoutWaitList') }})</span>
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.age') }}:
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ $t('offering.min') }}: {{ offering.minimumAge ? offering.minimumAge : '-' }} /
                            {{ $t('offering.max') }}: {{ offering.maximumAge ? offering.maximumAge : '-' }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.gender') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getGender(offering) }}
                        </div>
                    </div>
                </div>
                <div class="kgr-grid__cell">
                    <div
                        class="kgr-definitionList kgr-region kgr-region--lightGray kgr-region--rounded"
                        style="height: 100%;"
                    >
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.locations') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getLocationNamesForFields(offering.fields) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.instructors') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getInstructorNames(offering.instructors) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.requirements') }}:
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ offering.requirements ? offering.requirements : '-' }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.bookingMode') }}:
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ offering.isBookingModeOffering() ? $t('offering.bookingModeOptions.offering') : $t('offering.bookingModeOptions.appointment') }}
                        </div>
                    </div>
                </div>
                <div class="kgr-grid__cell">
                    <div
                        class="kgr-definitionList kgr-region kgr-region--lightGray kgr-region--rounded"
                        style="height: 100%;"
                    >
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.prices') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ getPrices(offering.prices) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.registrationRequested') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ (offering.registrationRequested ? $t('offering.yes') : $t('offering.no')) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.takesPlaceInSchoolHolidays') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ (offering.takesPlaceInSchoolHolidays ? $t('offering.yes') : $t('offering.no')) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.takesPlaceOnPublicHoliday') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ (offering.takesPlaceOnPublicHoliday ? $t('offering.yes') : $t('offering.no')) }}
                        </div>
                        <div class="kgr-definitionList__term">
                            {{ $t('offering.executiontype') }}
                        </div>
                        <div class="kgr-definitionList__definition">
                            {{ $t(`offering.${offering.executionType}`) }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="kgr-row">
            <h2 class="kgr-headline kgr-headline--h2">
                {{ $t('Termine') }}
            </h2>
        </div>
        <div
            class="kgr-row"
            style="position: relative; z-index: -1"
        >
            <div class="kgr-grid kgr-grid--gutters ">
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('von')"
                        :error="error"
                        field-name="bookingFrom"
                    >
                        <kgr-date-picker
                            v-model="bookingFrom"
                            @enter="reloadList"
                        />
                    </kgr-form-row>
                </div>
                <div class="kgr-grid__cell">
                    <kgr-form-row
                        :label="$t('bis')"
                        :error="error"
                        field-name="bookingTo"
                    >
                        <kgr-date-picker
                            v-model="bookingTo"
                            @enter="reloadList"
                        />
                    </kgr-form-row>
                </div>
            </div>
        </div>
        <kgr-loader v-if="loading" />
        <div v-else>
            <kgr-empty-data
                v-if="appointments.length === 0"
                :value="$t('In dem gewählten Zeitraum gibt es keine Termine')"
            />
            <kgr-generic-appointment-accordion
                v-else
                :appointments="appointments"
                :instructors="instructors"
                :offering="offering"
                :club-id="clubId"
                :user-id="userId"
                :booking-from="bookingFrom"
                :booking-to="bookingTo"
                :error="error"
            />
        </div>
        <kgr-update-offering-with-notification-modal
            :show-dialog="showCancellationModal"
            :headline="$t('Soll dieses Angebot storniert werden?')"
            show-booking-hint
            @confirm="onCancellationConfirm"
            @cancel="onCancelCancellation"
        />
    </div>
</template>

<script>
import AppointmentRepository from '../../js/repository/AppointmentRepository.js';
import BackToOverviewButton from './BackToOverviewButton.vue';
import DatePicker from '../common/form/picker/DatePicker.vue';
import EmptyData from '../../components/common/EmptyData.vue';
import Error from '../../js/model/Error.js';
import FormRow from '../common/form/FormRow.vue';
import GenericAppointmentAccordion from './appointment/GenericAppointmentAccordion.vue';
import Helper from '../../js/accounting/Helper.js';
import IconEdit from '../../components/common/icon/IconEdit.vue';
import Instructors from '../../js/repository/InstructorRepository.js';
import KgrIcon from '../../components/common/icon/Icon.vue';
import Loading from '../../components/common/Loading.vue';
import MessageBuilder from '../../js/offering/MessageBuilder.js';
import Offering from '../../js/dto/offering/Offering.js';
import OfferingBookingRepository from '../../js/repository/club/offering/OfferingBookingRepository.js';
import OfferingImageView from './OfferingImageView.vue';
import OfferingLiveSearchResultPreview from './OfferingLiveSearchResultPreview.vue';
import OfferingRepository from '../../js/repository/club/offering/OfferingRepository.js';
import UpdateOfferingWithNotificationModal from '@legacy/components/offering/UpdateOfferingWithNotificationModal.vue';
import moment from 'moment';

export default {
    name: 'KgrOfferingView',
    components: {
        'kgr-back-to-overview': BackToOverviewButton,
        'kgr-date-picker': DatePicker,
        'kgr-empty-data': EmptyData,
        'kgr-form-row': FormRow,
        'kgr-generic-appointment-accordion': GenericAppointmentAccordion,
        'kgr-icon': KgrIcon,
        'kgr-icon-edit': IconEdit,
        'kgr-loader': Loading,
        'kgr-offering-image-view': OfferingImageView,
        'kgr-offering-live-search-result-preview': OfferingLiveSearchResultPreview,
        'kgr-update-offering-with-notification-modal': UpdateOfferingWithNotificationModal,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        offering: {
            type: Offering,
            required: true,
        },
        userId: {
            type: Number,
            required: true,
        },
        error: {
            type: Error,
            required: true,
        },
        locale: {
            type: String,
            required: false,
            default: 'de-DE',
        },
        currency: {
            type: String,
            required: false,
            default: 'EUR',
        },
        duplicateGenericUrl: {
            type: String,
            required: true,
        },
        canDuplicate: {
            type: Boolean,
            required: true,
        },
        canEdit: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            loading: false,
            bookingFrom: moment().format('DD.MM.YYYY'),
            bookingTo: moment().add(3, 'month').format('DD.MM.YYYY'),
            appointments: [],
            bookings: [],
            waitList: [],
            pending: false,
            activeIndex: null,
            showEdit: false,
            instructors: [],
            showAddParticipant: false,
            newParticipant: null,
            buttonDisabled: false,
            loadingAddParticipant: false,
            selectedSalesListOfferingItems: [],
            showCancellationModal: false,
        };
    },
    computed: {
        bookableString() {
            return MessageBuilder.getBookableMessage(this.offering);
        },
    },
    watch: {
        bookingFrom(newValue) {
            if (newValue) {
                this.reloadList();
            }
        },
        bookingTo(newValue) {
            if (newValue) {
                this.reloadList();
            }
        },
    },
    created() {
        this.getAppointments(this.offering.id, this.bookingFrom, this.bookingTo);
        this.getInstructors().then((result) => {
            this.instructors.length = 0;
            this.instructors.push(...result);
        });
    },
    methods: {
        editParticipant() {
            this.showEdit = false;
            this.newParticipant = null;
            this.showAddParticipant = !this.showAddParticipant;
        },
        getInstructorNames(instructors) {
            if (instructors.length === 0) {
                return '-';
            }
            return instructors.map((instructor) => instructor.fullName).join(', ');
        },
        cancelAddParticipant() {
            this.newParticipant = null;
            this.showAddParticipant = false;
        },
        getGender(offering) {
            if (offering.bookableForWomen && offering.bookableForMen) {
                return this.$t('offering.mixed');
            } else if (offering.bookableForWomen) {
                return this.$t('offering.female');
            } else if (offering.bookableForMen) {
                return this.$t('offering.male');
            } else {
                return '-';
            }
        },
        getInterval(offering) {
            if (offering.appointmentSeriesList) {
                return offering.appointmentSeriesList.map(
                    (serie) => serie.interval
                        ? `${this.$t(`weekly_${serie.interval.weekday ? serie.interval.weekday : moment(serie.start, 'YYYY-MM-DD HH:mm').isoWeekday()}`)} (${this.$t(`interval.${serie.interval.type}`)})`
                        : `${this.$t(`weekday_${moment(serie.start, 'YYYY-MM-DD HH:mm').isoWeekday()}`)}, ${this.formattedDateTime(serie.start)}`,
                ).join(', ');
            } else {
                return '-';
            }
        },
        addParticipantToOffering(data, offering) {
            this.loadingAddParticipant = true;
            OfferingBookingRepository.addParticipantToOffering(this.clubId, offering.id, data, this.selectedSalesListOfferingItems)
                .then(() => {
                    this.$notify.success('Der Teilnehmer wurde hinzugefügt');
                    this.showAddParticipant = false;
                    this.newParticipant = null;
                    this.appointments.forEach((appointment) => appointment.bookingCount++);
                })
                .catch((error) => this.$notify.error(error.message))
                .finally(() => this.loadingAddParticipant = false);
        },
        getDepartmentNames(departments) {
            if (departments.length === 0) {
                return '-';
            }
            return departments.map((department) => department.name).join(', ');
        },
        getTeamNames(teams) {
            if (teams.length === 0) {
                return '-';
            }
            return teams.map((team) => team.name).join(', ');
        },
        getInstructors() {
            return Instructors.findAllByClub(this.clubId)
                .then((instructors) => {
                    const result = [];
                    instructors.sort((a, b) => a.fullName.toLowerCase().localeCompare(b.fullName.toLowerCase()));
                    instructors.forEach((instructor) => {
                        result.push({
                            value: instructor.id,
                            label: instructor.fullName,
                        });
                    },
                    );
                    return result;
                });
        },
        getLocationNamesForFields(fields) {
            const locationNames = [];
            if (fields.length !== 0) {
                fields.forEach((field) => {
                    if (!locationNames.includes(field.name)) {
                        locationNames.push((field.name));
                    }
                });
            }
            if (locationNames.length === 0) {
                return '-';
            }
            return locationNames.join(', ');
        },
        openConfirmCancellationModal() {
            this.showCancellationModal = true;
        },
        onCancellationConfirm(payload) {
            this.showCancellationModal = false;
            this.cancelAllOfferingAppointments(payload.notifyParticipants, payload.notifyClubEmployees);
        },
        onCancelCancellation() {
            this.showCancellationModal = false;
        },
        cancelAllOfferingAppointments(notifyParticipants, notifyClubEmployees) {
            OfferingRepository.cancelAllOfferingAppointments(this.offering, notifyParticipants, notifyClubEmployees)
                .then(() => {
                    this.$notify.success('offering.cancel.success');
                    this.appointments.forEach((appointment) => appointment.bookingCount = 0);
                    this.reloadList();
                })
                .catch((error) => {
                    if (error.status === 409) {
                        this.$notify.error(error.message);
                        return;
                    }
                    this.$notify.error('offering.cancel.error');
                },
                );
        },
        formatCurrency(amount) {
            return new Helper().numberFormat(amount, this.locale, this.currency);
        },
        getPrices(prices) {
            if (!prices || prices.length === 0) {
                return '-';
            }
            return prices.map((price) => this.getPriceDetails(price)).join(', ');
        },
        getPriceDetails(price) {
            const clubFeeName = price.clubFee && price.clubFee.amount ? this.formatCurrency(price.clubFee.amount.numerator / price.clubFee.amount.denominator) : '-';
            return `${this.$t(`offering.${price.type}`)} (${
                price.divergentAmount
                    ? this.formatCurrency(price.divergentAmount.numerator / price.divergentAmount.denominator)
                    : clubFeeName
            })`;
        },
        formattedDateTime(date) {
            return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
        },
        convertDate(date) {
            return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
        },
        reloadList() {
            this.getAppointments(this.offering.id, this.bookingFrom, this.bookingTo);
        },
        getAppointments(offeringId, start, end) {
            this.loading = true;
            this.appointments = [];
            AppointmentRepository.findAll(offeringId, this.convertDate(start), this.convertDate(end))
                .then((appointments) => this.appointments = appointments)
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);
        },
        redirectToEdit(offering) {
            window.location = `/backend/clubs/${this.clubId}/generic-offerings/${offering.id}/edit`;
        },
        downloadExcel() {
            window.location = `/api/club/offering/${this.offering.id}/appointments/${this.convertDate(this.bookingFrom)}/${this.convertDate(this.bookingTo)}/excel`;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
</style>
